import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null = checking, false = anon, object = user
  const [siteConfig, setSiteConfig] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  const loadConfig = useCallback(async () => {
    try {
      const { data } = await api.get("/site/config");
      setSiteConfig(data);
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { refresh(); loadConfig(); }, [refresh, loadConfig]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, siteConfig, refresh, login, register, logout, loadConfig }}>
      {children}
    </AuthContext.Provider>
  );
}
